<template>
  <div class="profile-page">
    <!-- Profile Card -->
    <div class="profile-card">
      <div class="profile-header">
        <div class="profile-info">
          <div class="avatar">
            <span>{{ (userInfo.username || 'N')[0].toUpperCase() }}</span>
          </div>
          <div class="user-details">
            <h2>{{ userInfo.username || '管理员' }}</h2>
            <span class="email">{{ userInfo.email || '未设置邮箱' }}</span>
          </div>
        </div>
        <div class="actions">
          <el-button type="primary" @click="openEdit">
            <i class="el-icon-edit"></i> 修改信息
          </el-button>
          <el-button type="warning" @click="openPassword">
            <i class="el-icon-key"></i> 修改密码
          </el-button>
        </div>
      </div>

      <!-- Info Grid -->
      <div class="info-grid">
        <div class="info-card">
          <i class="el-icon-user"></i>
          <div class="info-content">
            <label>用户名</label>
            <span>{{ userInfo.username || '-' }}</span>
          </div>
        </div>

        <div class="info-card">
          <i class="el-icon-message"></i>
          <div class="info-content">
            <label>邮箱</label>
            <span>{{ userInfo.email || '未设置' }}</span>
          </div>
        </div>

        <div class="info-card">
          <i class="el-icon-time"></i>
          <div class="info-content">
            <label>创建时间</label>
            <span>{{ formatDate(userInfo.created_at) }}</span>
          </div>
        </div>

        <div class="info-card">
          <i class="el-icon-refresh"></i>
          <div class="info-content">
            <label>更新时间</label>
            <span>{{ formatDate(userInfo.updated_at) }}</span>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="修改个人信息"
      :visible.sync="editDialogVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="90px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="editForm.username" autocomplete="off" placeholder="请输入用户名（至少3位）" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="editForm.email" autocomplete="off" placeholder="请输入邮箱地址" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="savingProfile" @click="submitEdit">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
        <el-form-item label="当前密码" prop="oldPassword">
          <el-input type="password" v-model="passwordForm.oldPassword" autocomplete="off" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="passwordForm.newPassword" autocomplete="new-password" />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input type="password" v-model="passwordForm.confirmPassword" autocomplete="new-password" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="savingPassword" @click="submitPassword">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils/timeUtil'

export default {
  name: 'AdminProfile',
  data () {
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入新密码'))
        return
      }
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      savingProfile: false,
      savingPassword: false,
      userInfo: {
        id: null,
        username: '',
        email: '',
        created_at: '',
        updated_at: ''
      },
      editDialogVisible: false,
      editForm: {
        username: '',
        email: ''
      },
      editRules: {
        username: [
          { min: 3, message: '用户名长度至少3位', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入合法邮箱地址', trigger: 'blur' }
        ]
      },
      passwordDialogVisible: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少 6 位', trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.fetchProfile()
  },
  methods: {
    async fetchProfile () {
      this.loading = true
      try {
        const res = await this.request.get('/namzar/admin/profile')
        if (res && res.code === 200 && res.data) {
          this.userInfo = {
            id: res.data.id || null,
            username: res.data.username || '',
            email: res.data.email || '',
            created_at: res.data.created_at || '',
            updated_at: res.data.updated_at || ''
          }
        } else if (res && res.data) {
          // 兼容直接返回 data 的情况
          this.userInfo = {
            id: res.data.id || null,
            username: res.data.username || '',
            email: res.data.email || '',
            created_at: res.data.created_at || '',
            updated_at: res.data.updated_at || ''
          }
        }
      } catch (res) {
        this.$message.error(res?.message || '获取个人信息失败')
      } finally {
        this.loading = false
      }
    },
    openEdit () {
      this.editForm = {
        username: this.userInfo.username || '',
        email: this.userInfo.email || ''
      }
      this.editDialogVisible = true
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },
    openPassword () {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.passwordDialogVisible = true
      this.$nextTick(() => {
        this.$refs.passwordForm && this.$refs.passwordForm.clearValidate()
      })
    },
    submitEdit () {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        
        // 检查是否有需要更新的字段
        const updateData = {}
        if (this.editForm.username && this.editForm.username.trim()) {
          updateData.username = this.editForm.username.trim()
        }
        if (this.editForm.email && this.editForm.email.trim()) {
          updateData.email = this.editForm.email.trim()
        }
        
        if (Object.keys(updateData).length === 0) {
          this.$message.warning('请至少填写一个需要更新的字段')
          return
        }
        
        this.savingProfile = true
        try {
          const res = await this.request.post('/namzar/admin/profile/update', updateData)
          this.$message.success(res?.message || '更新成功')
          this.editDialogVisible = false
          await this.fetchProfile()
        } catch (res) {
          this.$message.error(res?.message || '更新失败')
        } finally {
          this.savingProfile = false
        }
      })
    },
    submitPassword () {
      this.$refs.passwordForm.validate(async valid => {
        if (!valid) return
        this.savingPassword = true
        try {
          const res = await this.request.post('/namzar/admin/profile/updatePassword', {
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          })
          this.$message.success(res?.message || '密码修改成功，请重新登录')
          this.passwordDialogVisible = false
          // 清空表单
          this.passwordForm = {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
          }
        } catch (res) {
          this.$message.error(res?.message || '密码修改失败')
        } finally {
          this.savingPassword = false
        }
      })
    },
    formatDate (value) {
      if (!value) return '--'
      return formatDateTime(value)
    }
  }
}
</script>

<style scoped>
.profile-page {
  padding: 40px;
  background: #f5f7fa;
  min-height: 100%;
}

.profile-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.profile-header {
  padding: 32px;
  background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
}

.user-details h2 {
  margin: 0;
  font-size: 24px;
}

.email {
  font-size: 14px;
  opacity: 0.8;
  display: block;
  margin-top: 4px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  padding: 32px;
}

.info-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.info-card i {
  font-size: 24px;
  color: #1890ff;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.info-content label {
  font-size: 12px;
  color: #909399;
}

.info-content span {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  word-break: break-all;
}

.actions {
  display: flex;
  gap: 12px;
}

@media (max-width: 768px) {
  .profile-page {
    padding: 16px;
  }

  .profile-header {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .actions {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }

  .info-grid {
    grid-template-columns: 1fr;
    padding: 24px 16px;
  }
}
</style>

